<div class="header content-card">
  <h2>{{ 'WP-Delegations' | translate }}</h2>
</div>
<div class="content">
  <div class="content-card filters">
    <div class="top">
      <div class="top__left">
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
          <button mat-raised-button color="primary" (click)="openModal()">{{ 'DL-CreateDelegation' | translate }}</button>
          <button mat-raised-button color="accent" [matMenuTriggerFor]="menu">{{ 'DL-Actions' | translate }}</button>
        </div>
        <mat-menu #menu="matMenu">
          <span matTooltip="{{ 'DL-AcceptDelegationsTooltip' | translate }}" [matTooltipDisabled]="isAcceptDelegationButtonEnabled()">
            <button
              mat-menu-item
              [visibleWithPermissions]="['AcceptDelegation', 'Supervisor', 'FullDelegationsManagement']"
              [disabled]="!isAcceptDelegationButtonEnabled()"
              (click)="acceptSelectedDelegations()"
              >
              <span>{{ 'DL-AcceptDelegations' | translate }}</span>
            </button>
          </span>
          <span matTooltip="{{ 'DL-RejectDelegationsTooltip' | translate }}" [matTooltipDisabled]="isRejectDelegationButtonEnabled()">
            <button
              mat-menu-item
              [visibleWithPermissions]="['RejectDelegation', 'Supervisor', 'FullDelegationsManagement']"
              [disabled]="!isRejectDelegationButtonEnabled()"
              (click)="rejectSelectedDelegations()"
              >
              <span>{{ 'DL-RejectDelegations' | translate }}</span>
            </button>
          </span>
        </mat-menu>
      </div>
      <div class="top__right">
        <button (click)="resetFilters()" class="top__button top__button-clear">
          <mat-icon>close</mat-icon>
          {{ 'Reset' | translate }}
        </button>
        <button (click)="toggleFiltersPanel()" class="top__button top__button-filter">
          <mat-icon>filter_alt</mat-icon>
          {{ 'Filter' | translate }}
        </button>
      </div>
    </div>
    @if (areFiltersExpanded) {
      <div #filterSection>
        @if (areFiltersExpanded) {
          <app-delegation-list-filters [formGroup]="filtersFormGroup" (filterGridData)="filterData()">
          </app-delegation-list-filters>
        }
      </div>
    }
  </div>

  <div #tableContainer class="table-wrapper custom-table" [style.max-height]="listHeight">
    <mat-table #table matSort matSortActive="createdOn" matSortDirection="desc" matSortDisableClear [dataSource]="dataSource.delegations$ | async">
      <ng-container matColumnDef="select" sticky>
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            appearance="outline"
            (change)="$event ? masterToggle() : null"
            [checked]="dataSource.selection.hasValue() && isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !isAllSelected()"
            [matTooltip]="'SelectAll' | translate"
            matTooltipPosition="above"
            >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(row) : null"
            [checked]="dataSource.selection.isSelected(row)"
            >
          </mat-checkbox>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="lastName" [sticky]="screenService.isAboveMd$ | async">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'DL-FullName' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element"
          ><a
          class="user"
          [routerLink]="['/profile/' + element.WorkerId]"
          matTooltip="{{ 'WL-ShowWokerProfile' | translate }}"
          matTooltipPosition="above"
          >{{ element.FullName }}</a
          ></mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="client">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-Client' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.Client }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="startDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-StartDate' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.StartDate | date : 'yyyy-MM-dd' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="endDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-EndDate' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.EndDate | date : 'yyyy-MM-dd' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-Status' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.Status }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="organizationalUnit">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-OrganizationalUnit' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.OrganizationalUnit }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="createdOn">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-CreatedOn' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.CreatedOn | date : 'yyyy-MM-dd' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="destination">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-Destination' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.Destination }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="acceptedBy">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-UpdatedBy' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.AcceptedBy }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="acceptedOn">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-AcceptedOn' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.AcceptedOn | date : 'yyyy-MM-dd' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions" stickyEnd>
          <mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container> </ng-container>
            @if (screenService.isAboveMd$ | async) {
              <button mat-button class="button-text" [matMenuTriggerFor]="menuRow">
                <mat-icon class="material-icons-outlined">more_vert</mat-icon>
              </button>
            } @else {
              <button mat-icon-button [matMenuTriggerFor]="menuRow">
                <mat-icon class="material-icons-outlined">more_vert</mat-icon>
              </button>
            }


            <mat-menu #menuRow="matMenu" panelClass="actions-menu">
              <ng-container>
                <button mat-button (click)="openModal(element.WorkerId, element.Id)">
                  @if (isDelegationInEditMode(element)) {
                    <mat-icon class="material-icons-outlined">create</mat-icon>
                  }
                  @if (!isDelegationInEditMode(element)) {
                    <mat-icon class="material-icons-outlined">pageview</mat-icon>
                  }
                  @if (isDelegationInEditMode(element)) {
                    <span class="button-text">{{ 'Edit' | translate }}</span>
                  }
                  @if (!isDelegationInEditMode(element)) {
                    <span class="button-text">{{ 'Details' | translate }}</span>
                  }
                </button>
              </ng-container>
              @if (isSendToApprovalButtonVisible(element)) {
                <button
                  *ifHasPermissions="['ManageWorkerDelegations', 'ManageMyDelegations', 'Supervisor', 'FullDelegationsManagement']"
                  mat-button
                  (click)="sendToApproval(element.Id)"
                  >
                  <mat-icon class="material-icons-outlined">send</mat-icon>
                  <span class="button-text">{{ 'SendToApproval' | translate }}</span>
                </button>
              }
              @if (isDeleteButtonEnabled(element)) {
                <button
                  *ifHasPermissions="['ManageWorkerDelegations', 'ManageMyDelegations', 'Supervisor', 'FullDelegationsManagement']"
                  mat-button
                  (click)="deleteDelegation(element.Id)"
                  >
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                  <span class="button-text">{{ 'Delete' | translate }}</span>
                </button>
              }
              @if (isSettleDelegationButtonEnabled(element)) {
                <button
                *ifHasPermissions="[
                  'HRDelegationManagement',
                  'AccountingDelegationManagement',
                  'ManageWorkerDelegations',
                  'ManageMyDelegations',
                  'Supervisor',
                  'FullDelegationsManagement'
                ]"
                  mat-button
                  (click)="onSettleDelegationClick(element)"
                  >
                  <mat-icon class="material-icons-outlined">account_balance_wallet</mat-icon>
                  <span class="button-text">{{ 'DelegationSettlement' | translate }}</span>
                </button>
              }
              @if (isSettlementCorrectionButtonEnabled(element)) {
                <button
                  *ifHasPermissions="['ManageWorkerDelegations', 'ManageMyDelegations', 'Supervisor', 'FullDelegationsManagement']"
                  mat-button
                  (click)="onSettlementCorrectionClick(element)"
                  >
                  <mat-icon class="material-icons-outlined">warning</mat-icon>
                  <span class="button-text">{{ 'DelegationSettlementCorrection' | translate }}</span>
                </button>
              }
              @if (isAcceptDelegationButtonVisible(element)) {
                <button
                  mat-button
                  (click)="acceptSingleDelegation(element.Id)"
                  *ifHasPermissions="['ManageWorkerDelegations', 'Supervisor', 'FullDelegationsManagement']"
                  >
                  <mat-icon class="material-icons-outlined">thumb_up_alt</mat-icon>
                  <span class="button-text">{{ 'AcceptDelegation' | translate }}</span>
                </button>
              }
              @if (isRejectDelegationButtonVisible(element)) {
                <button
                  mat-button
                  (click)="rejectSingleDelegation(element.Id)"
                  *ifHasPermissions="['ManageWorkerDelegations', 'Supervisor', 'FullDelegationsManagement']"
                  >
                  <mat-icon class="material-icons-outlined">thumb_down_alt</mat-icon>
                  <span class="button-text">{{ 'RejectDelegation' | translate }}</span>
                </button>
              }
              @if (isAcceptDelegationCostsAsAccountingButtonVisible(element)) {
                <button mat-button (click)="acceptSingleDelegationCostsAsAccounting(element)" *ifHasPermissions="['AccountingDelegationManagement']">
                  <mat-icon class="material-icons-outlined">arrow_downward</mat-icon>
                  <span class="button-text">{{ 'AcceptDelegationCostsAsAccounting' | translate }}</span>
                </button>
              }
              @if (isCorrectionDelegationCostsAsAccountingButtonVisible(element)) {
                <button mat-button (click)="acceptSingleDelegationCostsAsAccounting(element)" *ifHasPermissions="['AccountingDelegationManagement']">
                  <mat-icon class="material-icons-outlined">warning</mat-icon>
                  <span class="button-text">{{ 'DelegationSettlementCorrection' | translate }}</span>
                </button>
              }
              @if (isDelegationCorrection(element)) {
                <button
                  *ifHasPermissions="['HRDelegationManagement', 'AccountingDelegationManagement', 'FullDelegationsManagement']"
                  mat-button
                  (click)="onSettleDelegationClick(element)"
                  >
                  <mat-icon class="material-icons-outlined">account_balance_wallet</mat-icon>
                </button>
              }
              @if (isCorrectionDelegationCostsAsAccountingButtonVisible(element) || isAcceptDelegationCostsAsAccountingButtonVisible(element)) {
                <button
                *ifHasPermissions="[
                  'ManageWorkerDelegations',
                  'ManageMyDelegations',
                  'Supervisor',
                  'HRDelegationManagement',
                  'FullDelegationsManagement'
                ]"
                  mat-button
                  (click)="onSettleDelegationClick(element)"
                  >
                  <mat-icon class="material-icons-outlined">account_balance_wallet</mat-icon>
                  <span class="button-text">{{ 'DelegationSettlement' | translate }}</span>
                </button>
              }
            </mat-menu>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>

    <mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"> </mat-paginator>
  </div>
